import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatListItem } from '@blocks-react/components/ListItem';
import { CatSkeleton } from '@blocks-react/components/Skeleton';
import cx from 'classnames';
import styles from './HeaderCartListItem.module.scss';
export const HeaderCartListItemSkeleton = () => {
    return (_jsx(CatListItem, { "data-testid": "header-cart-list-item-skeleton", children: _jsxs("div", { className: "d-flex", children: [_jsx("div", { className: cx('me-3', styles['header__cart-list-item--image']), children: _jsx(CatSkeleton, { size: "lg" }) }), _jsxs("div", { children: [_jsx("div", { className: "my-1", children: _jsx(CatSkeleton, { size: "sm", width: "300px" }) }), _jsx(CatSkeleton, { size: "sm", width: "200px" })] })] }) }));
};
